import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import type { PaymentMethodAdapter, PaymentAdapterContext } from "../types";

const PayPalView: React.FC<PaymentAdapterContext> = ({
  session,
  amount,
  hideTitle = false,
}) => {
  const approvalToken = session.metadata?.approvalToken ?? session.sessionId;
  const redirectUrl =
    session.redirectUrl ??
    `https://www.sandbox.paypal.com/checkoutnow?token=${approvalToken}`;

  return (
    <Card id="paypal-adapter">
      {hideTitle ? null : (
        <CardHeader>
          <h2 className="text-xl font-semibold">Pagar com PayPal</h2>
        </CardHeader>
      )}
      <CardContent className={hideTitle ? "space-y-4 pt-6" : "space-y-4"}>
        <p className="text-text-secondary text-sm">
          Você será redirecionado ao PayPal para autorizar o pagamento de{" "}
          <strong>R$ {amount.toFixed(2).replace(".", ",")}</strong>. Nenhuma senha é coletada nesta
          página.
        </p>
        <Button
          type="button"
          variant="outline"
          className="w-full"
          onClick={() => window.open(redirectUrl, "_blank", "noopener,noreferrer")}
        >
          Continuar no PayPal
        </Button>
        <p className="text-xs text-text-tertiary">
          Depois de aprovar no PayPal, volte a esta aba. A confirmação costuma levar poucos segundos.
        </p>
      </CardContent>
    </Card>
  );
};

export const PayPalAdapter: PaymentMethodAdapter = {
  provider: "Paypal",
  method: "PayPal",
  render: (context) => <PayPalView {...context} />,
};
